import React, { useState, useEffect,  useMemo} from "react";
import { message, Typography, Card, Col, Row ,   Alert, Grid,  Statistic,} from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import DemoColumn from "./tester_stats";
import useLogout from "../useLogout";

const { useBreakpoint } = Grid;

const duplicateMonthlyCount =
  "https://jqh0cp25wl.execute-api.us-east-1.amazonaws.com/dev/duplicate-otp-current-month";
const dailyOTPCount =
  "https://jqh0cp25wl.execute-api.us-east-1.amazonaws.com/dev/otp-today";
const monthlyOTPCount =
  "https://jqh0cp25wl.execute-api.us-east-1.amazonaws.com/dev/otp-current-month";
const previousMonthOTPCount =
  "https://jqh0cp25wl.execute-api.us-east-1.amazonaws.com/dev/otp-last-month";
const configSettingAPI = process.env.REACT_APP_ConfigSetting;
const bonusApi = process.env.REACT_APP_API_BonusURL;

const Testers = () => {
  const { Title } = Typography;
  const [messageApi, contextHolder] = message.useMessage();
  const [dailyCount, setDailyCount] = useState(0);
  const [lowerLimitPayout, setLowerLimitPayout] = useState();
  const [bonusUSD, setBonusUSD] = useState();
  const [monthlyCount, setMonthlyCount] = useState(0);
  const [previousMonthCount, setPreviousMonthCount] = useState(0);
  const [duplicateMonthCount, setDuplicateMonthCount] = useState(0);
  const [paymentRate, setPaymentRate] = useState(0.01);

  const screens = useBreakpoint();

  const logout = useLogout();

  useEffect(() => {
    fetchOTPData();
  }, []);

  const storedUser = localStorage.getItem("user");
  const user = JSON.parse(storedUser);

  const fetchOTPData = async () => {
    try {
      const userId = user.userId;

      // Fetch daily count
      const dailyResponse = await fetch(`${dailyOTPCount}/${userId}`);
      const dailyData = await dailyResponse.json();

      if (dailyData.inactive) {
        logout();
      } else {
        setDailyCount(dailyData.otp_today);
      }

      // Fetch previous month's count
      const previousMonthCountResponse = await fetch(
        `${previousMonthOTPCount}/${userId}`
      );
      const prevMonthData = await previousMonthCountResponse.json();
      if (prevMonthData.inactive) {
        logout();
      } else {
        setPreviousMonthCount(prevMonthData.otp_current_month);
      }

      // Fetch monthly count
      const monthlyResponse = await fetch(`${monthlyOTPCount}/${userId}`);
      const monthlyData = await monthlyResponse.json();
      if (monthlyData.inactive) {
        logout();
      } else {
        setMonthlyCount(monthlyData.otp_current_month);
      }

      const monthlyDuplicateResponse = await fetch(
        `${duplicateMonthlyCount}/${userId}`
      );
      const monthlyDuplicateData = await monthlyDuplicateResponse.json();
      if (monthlyDuplicateData.inactive) {
        logout();
      } else {
        setDuplicateMonthCount(
          monthlyDuplicateData.duplicate_otp_current_month
        );
      }
       // Fetch bonus details
       const bonusResponse = await fetch(`${bonusApi}/${userId}`);
       const bonusData = await bonusResponse.json();
       
       console.log('bonusData', bonusData);
       
       // Parse the body string into a JavaScript object
       const bodyObject = JSON.parse(bonusData.body);
       
       console.log('bodyObject', bodyObject);
       console.log('bodyObject.current_month_bonus', bodyObject.current_month_bonus);
       
       const currentBonus = bodyObject ? bodyObject.current_month_bonus : bonusData.current_month_bonus;
       
       console.log('current_month_bonus', currentBonus);
       setBonusUSD(currentBonus); 

      const configSetting = await fetch(configSettingAPI);
      const bonusLimit = await configSetting.json();
      // setBonusUSD(bonusLimit.body.bonus_limit);
      setLowerLimitPayout(bonusLimit.body.payout_lower_limit);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

   const calculateValidOTPsAndPayment = (monthlyCount, duplicateMonthCount) => {
      const validOTPs = monthlyCount - duplicateMonthCount;
      let payment = validOTPs * paymentRate;
      console.log("payment", payment);
  
      return { validOTPs, payment };
    };
  
    const { validOTPs, payment } = useMemo(
      () => calculateValidOTPsAndPayment(monthlyCount, duplicateMonthCount),
      [monthlyCount, duplicateMonthCount]
    );

  return (
    <>
      {contextHolder}
      <Title level={3}>Your Profile</Title>
        <Alert
                  message={`Per OTP payment rate is 0.01$(USD)`}
                  banner
                  style={{ marginBottom: "16px" }}
                />
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
           <Col xs={24} sm={12} md={6}>
               <Card
                             bordered={false}
                             style={{
                               border: "1px solid #d8d8d8",
                               borderRadius: "8px",
                               minHeight: screens.md ? "8.5rem" : "auto",
                               display: "flex",
                               flexDirection: "column",
                               justifyContent: "center"
                             }}
                           >
                             <Statistic
                               title="Total Received Tests Today"
                               value={dailyCount}
                               valueStyle={{ color: "#3f8600",  fontSize: "20px" }}
                               prefix={<ArrowUpOutlined />}
                             />
                           </Card>
        </Col>
           <Col xs={24} sm={12} md={6}>
        <Card
                            bordered={false}
                            style={{
                              border: "1px solid #d8d8d8",
                              borderRadius: "8px",
                              minHeight: screens.md ? "8.5rem" : "auto",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center"
                            }}
                          >
                            <Statistic
                              title="Received Tests this Month"
                              value={monthlyCount}
                              valueStyle={{ color: "#3f8600",  fontSize: "20px" }}
                              prefix={<ArrowUpOutlined />}
                            />
                          </Card>
        </Col>
           <Col xs={24} sm={12} md={6}>
           <Card
                    bordered={false}
                    style={{
                      border: "1px solid #d8d8d8",
                      borderRadius: "8px",
                      minHeight: screens.md ? "8.5rem" : "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center"
                    }}
                  >
                    <Statistic
                      title="Duplicate Tests this Month"
                      value={duplicateMonthCount}
                      valueStyle={{ color: "#cf1322",  fontSize: "20px" }}
                      prefix={<ArrowDownOutlined />}
                    />
                  </Card>
        </Col>
          <Col xs={24} sm={12} md={6}>
           <Card
                              bordered={false}
                              style={{
                                border: "1px solid #d8d8d8",
                                borderRadius: "8px",
                                minHeight: screens.md ? "8.5rem" : "auto",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center"
                              }}
                            >
                              <Statistic
                                title="Valid Tests for this Month"
                                value={monthlyCount- duplicateMonthCount}
                                valueStyle={{ color: "#3f8600",  fontSize: "20px" }}
                                prefix={<ArrowUpOutlined />}
                              />
                            </Card>        </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col xs={24} sm={12} md={6}>
    <Card
      bordered={false}
      style={{
        border: "1px solid #d8d8d8",
        borderRadius: "8px",
        minHeight: screens.md ? "8.5rem" : "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >
      <div style={{ textAlign: "center" }}>
        <Statistic
          title="Total Payment This Month"
          value={payment + (bonusUSD || 0)}
          precision={3}
          valueStyle={{ color: "#3f8600", fontSize: "18px", fontWeight: "bold" }}
          suffix="$(USD)"
        />
        <div 
          style={{ 
            borderTop: "1px dashed #d9d9d9", 
            margin: "12px 0", 
            paddingTop: "8px",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap"
          }}
        >
          <div style={{ minWidth: "45%" }}>
            <Statistic
              title={<span style={{ fontSize: "12px" }}>Base</span>}
              value={payment}
              precision={3}
              valueStyle={{ color: "#3f8600", fontSize: "14px" }}
              suffix="$"
            />
          </div>
          <div style={{ minWidth: "45%" }}>
            <Statistic
              title={<span style={{ fontSize: "12px" }}>Bonus</span>}
              value={bonusUSD || 0}
              precision={3}
              valueStyle={{ color: "#FFC000", fontSize: "14px" }}
              suffix="$"
            />
          </div>
        </div>
      </div>
    </Card>
  </Col>
  
      </Row>

      <DemoColumn />
    </>
  );
};
export default Testers;
